// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__3jhOW","img":"logo_img__1xgCP"};